import React, { useEffect, useState } from "react";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import PromotedImagePreview from "../../../creativePreviews/PromotedImagePreview";
import RectangleClassifieds from "../../../creativePreviews/RectangleClassifieds";
import { proxyDownload } from "../../../utils/proxyDownload";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";
import RotatableImage from "../utils/RotatableImage";

const getFileType = (url) => {
  const extension = url.split(".").pop()?.toLowerCase();
  const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv", "webm", "mkv"];
  return videoExtensions.includes(extension) ? "video" : "image";
};






const ImagesModal = ({ isOpen, onClose, adData }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [mediaUrls, setMediaUrls] = useState([]);
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);

  const handleMediaPrev = () => {
    setCurrentMediaIndex((prevIndex) => (prevIndex - 1 + mediaUrls.length) % mediaUrls.length);
  };

  const handleMediaNext = () => {
    setCurrentMediaIndex((prevIndex) => (prevIndex + 1) % mediaUrls.length);
  };

  useEffect(() => {
    const getMedia = async () => {
      const result = await API({
        url: "/alpha_cst_designer/getMedia",
        method: "POST",
        data: {
          creative_id: adData?.creative_id,
        },
      });
      if (result?.status === "SUCCESS") {
        const processedMedia = result?.data?.map((item) => ({
          url: item?.img_url,
          type: getFileType(item?.img_url),
        }));
        setMediaUrls(processedMedia);
      }
    };
    getMedia();
  }, [adData]);

  const handleDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      const files = [];
      if (mediaUrls.length > 0) {
        mediaUrls.forEach((media) => {
          files.push(media.url);
        });
      } else {
        const imgUrls = adData?.img_urls || {};
        if (imgUrls?.main) files.push(imgUrls.main);
        if (Array.isArray(imgUrls?.sub)) {
          imgUrls?.sub?.forEach((obj) => {
            if (typeof obj === "string") files.push(obj);
            else if (obj?.url) files.push(obj.url);
          });
        }
      }

      await proxyDownload(files, adData?.creative_name || "download");
    } catch (error) {
      Toast("failed", "Download failed.");
    } finally {
      setIsDownloading(false);
    }
  };


  const previewProps = {
    img_urls: "",
    video_urls: mediaUrls?.find((item) => item?.type === "video")?.url || null,
    head_line: adData?.head_line,
    description: adData?.description,
    click_url: adData?.click_url,
    button_enabled: 0,
    button_link: adData?.click_url,
    name: adData?.creative_name,
    position: adData?.position,
  };

  if (!isOpen) return;

  return (
    <SlDrawer label="Images Preview" style={{ "--size": "70vw" }} placement="end" open={isOpen} onSlAfterHide={onClose}>
      <div className="p-4 max-h-[90vh] overflow-y-auto overflow-visible">
        <h6 className="m-2 px-2 py-1 rounded-lg">{adData?.creative_name}</h6>
        <button className={`mx-3 px-2 py-1 rounded-lg shadow-md ${isDownloading ? "bg-green-500 cursor-progress" : "bg-blue-400"}`} onClick={handleDownload} disabled={isDownloading}>
          Download {adData?.ad_type === "classified" ? "Preview" : mediaUrls?.length > 1 ? "All as ZIP" : "Preview"}
        </button>
        <div className="flex gap-3 overflow-x-auto my-2 py-1">
          {mediaUrls?.map((imageObj, idx) => (
            <img
              src={imageObj?.url}
              alt={`thumb-${idx}`}
              onClick={() => setCurrentMediaIndex(idx)}
              className={`w-16 h-16 object-cover rounded-lg cursor-pointer border-2 transition-transform duration-200 ${idx === currentMediaIndex ? "border-blue-500 ring-2 ring-blue-400 scale-105 m-1" : "border-gray-300 hover:border-blue-300"}`}
            />
          ))}
        </div>
        <div>showing image : {mediaUrls[currentMediaIndex]?.type} - {currentMediaIndex}</div>
        {mediaUrls?.length > 0 && currentMediaIndex !== null ? (
          <div className="relative">
            {adData?.ad_creative_sub_type === "classified" && mediaUrls?.[currentMediaIndex]?.type === "image" ? (
              <RectangleClassifieds
                preview={{
                  cla_brand_caption: adData?.cla_brand_caption,
                  logo_urls: adData?.cla_brand_img,
                  brand_name: adData?.cla_brand_name,
                  btn_text_bgclr: adData?.cla_btn_bg_clr,
                  btn_icon: adData?.cla_btn_icon,
                  button_text: adData?.cla_btn_txt,
                  btn_text_clr: adData?.cla_btn_txt_col,
                  btn_url: adData?.cla_btn_url,
                  no_of_rec: adData?.cla_no_of_rec,
                  sub_type: adData?.cla_sub_type,
                  img_urls: mediaUrls?.[currentMediaIndex]?.url,
                  head_line: adData?.headline,
                  description: adData?.description,
                  button_enabled: !!adData?.cla_btn_txt,
                }}
              />
            ) : adData?.ad_creative_sub_type === "promoted_video_story" || adData?.ad_creative_sub_type === "promoted_image_story" ? (
              mediaUrls?.[currentMediaIndex]?.type === "video" ? (
                <iframe
                  src={mediaUrls?.[currentMediaIndex]?.url}
                  className="w-full h-full object-cover"
                  title="Video Preview - Promoted Story"
                />
              ) : (
                <PromotedImagePreview preview={{ ...previewProps, img_urls: mediaUrls?.[currentMediaIndex]?.url }} />
              )
            ) : adData?.ad_creative_sub_type === "half_video" ? (
              <iframe
                src={mediaUrls?.[currentMediaIndex]?.url}
                className="w-full h-full object-cover"
                title="Video Preview - Half Video"
              />
            ) : mediaUrls?.[currentMediaIndex]?.type === "image" ? (
              <RotatableImage
                src={mediaUrls?.[currentMediaIndex]?.url}
                alt={`creative-${currentMediaIndex}`}
                className="w-full h-auto object-contain"
              />
            ) : (
              <iframe
                src={mediaUrls?.[currentMediaIndex]?.url}
                className="w-full h-full object-cover"
                title="Video Preview - Default"
              />
            )}
            {mediaUrls?.length > 1 && (
              <>
                <button onClick={handleMediaPrev} className="absolute left-3 top-1/2 transform -translate-y-1/2 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-3 shadow-lg transition-all duration-200 focus:outline-none z-10" aria-label="Previous Image">
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button onClick={handleMediaNext} className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-3 shadow-lg transition-all duration-200 focus:outline-none z-10" aria-label="Next Image">
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </>
            )}
          </div>
        ) : (
          <div className="font-bold text-lg text-center flex items-center justify-center w-full h-64 border rounded bg-gray-100 text-gray-500">NO MEDIA FOUND</div>
        )}
      </div>
    </SlDrawer>
  );
};

export default ImagesModal;
